enum EnumReportType {
    AllCustomer = 'AllCustomer',
    PointCustomer = 'PointCustomer',
    CourseCustomer = 'CourseCustomer',
    PointTx = 'PointTx',
    CourseTx = 'CourseTx',
    MemberLevel = 'MemberLevel',
}

export default EnumReportType